import { render } from "./ViewBankstatement.vue?vue&type=template&id=ddfaa362"
import script from "./ViewBankstatement.vue?vue&type=script&lang=js"
export * from "./ViewBankstatement.vue?vue&type=script&lang=js"

import "./ViewBankstatement.vue?vue&type=style&index=0&id=ddfaa362&lang=css"
script.render = render

export default script